import React,{useState} from "react";
import NewRoutes from "./Routes/NewRote";
import AdminRoute from "./Routes/AdminRoute";
import { UserProvider } from "./Routes/usercontext";
import axiosInstance from "./axiosConfig";
import SessionExpiredModal from "./component/SessionExpire/SessionExpiredModal";
// import { Route, Routes } from "react-router-dom";

function App() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleLogin = () => {
    // Redirect to the login page or show the login form
    window.location.href = '/login'; // Update this based on your routing
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    window.location.href = '/login'; // Adjust to your login route
  };

  // You can use the axios instance with interceptors already set up
  // axiosInstance.interceptors.response.use(
  //   (response) => response,
  //   async (error) => {
  //     const originalRequest = error.config;

  //     if (error.response.status === 401 && !originalRequest._retry) {
  //       originalRequest._retry = true;

  //       try {
  //         const { data } = await axiosInstance.post('/auth/refresh-token');
  //         axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
  //         return axiosInstance(originalRequest);
  //       } catch (refreshError) {
  //         if (refreshError.response && (refreshError.response.status === 401 || refreshError.response.status === 403)) {
  //           setIsModalOpen(true); // Open the modal if the refresh token fails
  //         }
  //       }
  //     }
  //     return Promise.reject(error);
  //   }
  // );


  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;

        // Check if the error is 401 and the request is not retried yet
        if ((error.response.status === 401||error.response.status === 403)  && !originalRequest._retry) {
            originalRequest._retry = true;

            try {
                const { data } = await axiosInstance.post('/auth/refresh-token');
                console.log(data)
                if(!data){
                  window.location.href = '/login';
                  return
                }
                axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${data.accessToken}`;
                return axiosInstance(originalRequest);
            } catch (refreshError) {
              console.log(refreshError)
                // Handle the refresh token error
                window.location.href = '/login';
            }
        }
        return Promise.reject(error);
    }
);






  return (
    <div>
      <NewRoutes />

     {/* Wrap only AdminRoute with UserProvider */}
     <UserProvider>
        <AdminRoute />
      </UserProvider>

      <SessionExpiredModal
        isOpen={isModalOpen}
        onClose={handleModalClose}
        onLogin={handleLogin}
      />
    </div>
  );
}

export default App;
